/* One native Shopify form, a floating purchase bar and an accessible size dialog. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('.soyul-pdp').forEach(root => {
      if (root.dataset.purchaseReady) return;
      const dialog = root.querySelector('[data-soyul-size-dialog]');
      const main = root.querySelector('[data-soyul-variant-id]');
      const submit = root.querySelector('[ref="addToCartButton"]');
      const compact = root.querySelector('[data-soyul-compact-add]');
      const compactLabel = compact?.querySelector('[data-soyul-compact-label]');
      const form = main?.closest('form');
      if (!form || !submit || !compact) return;
      let variants, optionNames;
      try { const data = JSON.parse(root.querySelector('[data-soyul-variants]').textContent); variants = data.variants; optionNames = data.names || []; } catch { return; }
      const controller = new AbortController();
      const on = (el, event, fn, extra = {}) => el.addEventListener(event, fn, {signal:controller.signal, ...extra});
      const hasDefaultVariant = root.dataset.soyulDefaultVariant === 'true';
      // A URL, native hydration or a single labelled size is not a size choice.
      let chosen = hasDefaultVariant;
      main.value = hasDefaultVariant ? String(variants[0].id) : '';
      const initialUrl = new URL(location.href);
      if (!hasDefaultVariant && initialUrl.searchParams.has('variant')) {
        initialUrl.searchParams.delete('variant');
        history.replaceState(history.state, '', initialUrl);
      }
      const canUseDialog = dialog && typeof dialog.showModal === 'function';
      let opener;
      const bar = root.querySelector('.soyul-pdp__compact');
      const pageWrapper = document.querySelector('.page-wrapper');
      const floatingEnd = document.querySelector('.soyul-related') || document.querySelector('footer');
      const triggers = [...root.querySelectorAll('[data-soyul-size-open]')];
      let rows = [...(dialog?.querySelectorAll('[data-soyul-size-id]') || [])];
      const optionValues = new Map(variants.map(v => [v.id, v.options || [v.option1, v.option2, v.option3]]));
      const combined = variants.map(v => v.title.match(/^(XXS|XS|S|M|L|XL|XXL|2XL|3XL|4XL)\s*(?:\/|–|—|-)\s*(.+)$/i));
      if (optionNames.length === 1 && combined.every(Boolean)) {
        optionNames = ['Taille', 'Coloris'];
        variants.forEach((variant, index) => optionValues.set(variant.id, [combined[index][1].toUpperCase(), combined[index][2]]));
      }
      const sizeIndex = optionNames.findIndex(name => /^(taille|size)$/i.test(name.trim()));
      const colorIndex = optionNames.findIndex(name => /^(couleur|coloris|color|colour)$/i.test(name.trim()));
      const optionAt = (variant, index) => optionValues.get(variant.id)?.[index] ?? variant[`option${index + 1}`];
      const sizeOf = variant => optionAt(variant, sizeIndex >= 0 ? sizeIndex : 0) || variant.title.split('/')[0].trim();
      const order = ['XXS','XS','S','M','L','XL','XXL','2XL','3XL','4XL'];
      const rank = size => { const value = order.indexOf(size.toUpperCase()); return value < 0 ? order.length : value; };
      rows.sort((a,b) => rank(sizeOf(variants.find(v => String(v.id) === a.dataset.soyulSizeId))) - rank(sizeOf(variants.find(v => String(v.id) === b.dataset.soyulSizeId))));
      rows.forEach(row => row.parentElement.append(row));
      // Two independent choices still resolve to the original Shopify variant ID.
      const separateColor = canUseDialog && optionNames.length === 2 && sizeIndex >= 0 && colorIndex >= 0;
      let selectedColor = null;
      let colorButtons = [];
      if (separateColor) {
        const label = document.createElement('p');
        label.className = 'soyul-size-dialog__select-label';
        label.textContent = '1. Choisissez votre coloris';
        const colors = document.createElement('div');
        colors.className = 'soyul-size-colors';
        colors.setAttribute('aria-label', 'Coloris');
        [...new Set(variants.map(v => optionAt(v, colorIndex)))].forEach(color => {
          const button = document.createElement('button');
          button.type = 'button'; button.textContent = color;
          button.setAttribute('aria-pressed', 'false');
          on(button, 'click', () => {
            if (root.dataset.purchaseBusy === 'true') return;
            selectedColor = color; chosen = false; main.value = '';
            main.dispatchEvent(new Event('change', {bubbles:true}));
          });
          colors.append(button); colorButtons.push(button);
        });
        const sizeLabel = dialog.querySelector('.soyul-size-dialog__select-label');
        sizeLabel.textContent = '2. Choisissez votre taille (après le coloris)';
        sizeLabel.before(label, colors);
        const list = dialog.querySelector('.soyul-size-list');
        list.replaceChildren();
        rows = [...new Set(variants.map(sizeOf))].sort((a,b) => rank(a) - rank(b)).map(size => {
          const row = document.createElement('button');
          row.type = 'button'; row.dataset.soyulSize = size;
          row.setAttribute('aria-pressed', 'false');
          const name = document.createElement('span'); name.textContent = size;
          const status = document.createElement('small'); status.dataset.soyulSizeStatus = '';
          const check = document.createElement('span'); check.className = 'soyul-size-check';
          check.setAttribute('aria-hidden', 'true'); check.textContent = '✓';
          row.append(name, status, check); list.append(row); return row;
        });
      }
      // The existing variant controller remains the single source of truth.
      // Move its controls into the purchase form, leaving the dialog for measurements.
      const inlineChoice = root.querySelector('[data-soyul-inline-choice]');
      const inlineOptions = root.querySelector('[data-soyul-inline-options]');
      if (inlineChoice && inlineOptions && canUseDialog && !hasDefaultVariant) {
        if (separateColor) {
          const colors = dialog.querySelector('.soyul-size-colors');
          const colorLabel = colors?.previousElementSibling;
          if (colorLabel) { colorLabel.textContent = 'Coloris'; inlineOptions.append(colorLabel); }
          if (colors) inlineOptions.append(colors);
        }
        const list = dialog.querySelector('.soyul-size-list');
        if (list) inlineOptions.append(list);
        inlineChoice.hidden = false;
        dialog.querySelector('.soyul-size-dialog__select-label')?.remove();
      } else if (hasDefaultVariant) {
        dialog.querySelector('.soyul-size-list')?.remove();
        dialog.querySelector('.soyul-size-dialog__select-label')?.remove();
      }
      const measuresToggle = dialog?.querySelector('[data-soyul-measures-toggle]');
      const measuresPanel = dialog?.querySelector('[data-soyul-measures-panel]');
      const measuresContent = dialog?.querySelector('[data-soyul-measures-content]');
      const selectedMeasures = root.querySelector('[data-soyul-selected-measures]');
      const price = root.querySelector('[data-soyul-price]');
      const compactSelect = root.querySelector('[data-soyul-compact-select]');
      const priceCache = new Map();
      let lastPriceId;
      let lastMeasuresId;

      function sourceGuide() {
        return document.getElementById('guide-des-tailles');
      }

      function hydrateMeasures() {
        if (!measuresContent || measuresContent.dataset.loaded === 'true') return;
        const source = sourceGuide();
        const table = source?.querySelector('.soyul-size-guide__scroll');
        const notes = source?.querySelector('.soyul-size-guide__notes');
        if (table) {
          measuresContent.append(table.cloneNode(true));
          if (notes) measuresContent.append(notes.cloneNode(true));
        } else {
          const fallback = document.createElement('a');
          fallback.href = '/pages/guide-des-tailles';
          fallback.textContent = 'Consulter le guide général';
          measuresContent.append(fallback);
        }
        measuresContent.dataset.loaded = 'true';
      }

      function measurementFor(variant) {
        const table = sourceGuide()?.querySelector('table');
        if (!table || !variant) return '';
        const size = sizeOf(variant).toUpperCase();
        const headers = [...table.querySelectorAll('thead th')].map(cell => cell.textContent.trim());
        const row = [...table.querySelectorAll('tbody tr')].find(item => item.cells[0]?.textContent.trim().toUpperCase() === size);
        if (!row) return '';
        const values = [...row.cells].map(cell => cell.textContent.trim());
        return values.slice(1).map((value, index) => `${headers[index + 1]} ${value} cm`).join(' · ');
      }

      function sync() {
        const variant = variants.find(v => String(v.id) === main.value);
        const canPurchase = chosen && !!variant?.available;
        const busy = root.dataset.purchaseBusy === 'true';
        root.dataset.soyulCanPurchase = String(canPurchase);
        root.dataset.soyulSelection = chosen && variant ? String(variant.id) : '';
        const label = !variants.some(v => v.available) ? 'Épuisé' : !chosen ? 'Sélectionner une taille' : !variant?.available ? 'Épuisé' : 'Ajouter au panier';
        submit.disabled = !canPurchase || busy;
        submit.setAttribute('aria-disabled', String(submit.disabled));
        compact.disabled = busy || (!variants.some(v => v.available));
        compact.setAttribute('aria-disabled', String(compact.disabled));
        triggers.forEach(button => button.disabled = busy);
        if (separateColor) {
          colorButtons.forEach(button => {
            button.disabled = busy;
            button.setAttribute('aria-pressed', String(button.textContent === selectedColor));
          });
          rows.forEach(row => {
            const match = selectedColor === null ? null : variants.find(v => sizeOf(v) === row.dataset.soyulSize && optionAt(v, colorIndex) === selectedColor);
            row.dataset.soyulSizeId = match ? String(match.id) : '';
            row.disabled = busy || !match?.available;
            row.querySelector('[data-soyul-size-status]').textContent = selectedColor === null ? 'Choisir un coloris' : !match ? 'Indisponible dans ce coloris' : !match.available ? 'Épuisé' : '';
          });
        } else rows.forEach(row => row.disabled = busy || !variants.find(v => String(v.id) === row.dataset.soyulSizeId)?.available);
        main.disabled = busy;
        if (compactSelect) compactSelect.value = main.value;
        if (compactLabel) compactLabel.textContent = busy ? 'Ajout en cours…' : !variants.some(v => v.available) ? 'Épuisé' : !chosen ? 'Choisir ma taille' : label;
        const availability = root.querySelector('[data-soyul-availability]');
        if (availability) {
          const available = chosen && variant ? variant.available : variants.some(v => v.available);
          availability.dataset.available = String(available);
          availability.querySelector('[data-soyul-stock-label]').textContent = !available ? 'Épuisé' : 'Disponible';
        }
        const text = submit.querySelector('.add-to-cart-text__content span span');
        if (text) text.textContent = busy ? 'Ajout en cours…' : label;
        root.querySelectorAll('[data-soyul-size-label]').forEach(el => el.textContent = chosen && variant ? variant.title : 'Choisir');
        rows.forEach(row => row.setAttribute('aria-pressed', String(chosen && row.dataset.soyulSizeId === main.value)));
        if (selectedMeasures && lastMeasuresId !== main.value) {
          const measurements = chosen ? measurementFor(variant) : '';
          selectedMeasures.textContent = measurements ? `${variant.title} sélectionnée · ${measurements}` : '';
          selectedMeasures.hidden = !measurements;
          lastMeasuresId = main.value;
        }
        if (variant && lastPriceId !== variant.id) {
          let template = priceCache.get(variant.id);
          if (!template) {
            template = root.querySelector(`[data-soyul-variant-price="${variant.id}"]`);
            priceCache.set(variant.id, template);
          }
          if (template) {
            price?.replaceChildren(template.content.cloneNode(true));
            root.querySelector('[data-soyul-compact-price]')?.replaceChildren(template.content.cloneNode(true));
          }
          lastPriceId = variant.id;
        }
      }
      function open(button) {
        if (!canUseDialog) { main.focus(); return; }
        if (dialog.open) return;
        opener = button;
        if (measuresToggle && measuresPanel) {
          hydrateMeasures();
          measuresToggle.setAttribute('aria-expanded', 'true');
          measuresPanel.hidden = false;
        }
        dialog.showModal();
        document.documentElement.classList.add('soyul-size-open');
        const colorChoice = !inlineChoice && separateColor && (colorButtons.find(button => button.getAttribute('aria-pressed') === 'true' && !button.disabled) || colorButtons.find(button => !button.disabled));
        const sizeChoice = !inlineChoice && (rows.find(row => row.getAttribute('aria-pressed') === 'true' && !row.disabled) || rows.find(row => !row.disabled));
        (colorChoice || sizeChoice || dialog.querySelector('[data-soyul-size-close]')).focus({preventScroll:true});
        dialog.scrollTop = 0;
      }
      triggers.forEach(button => {
        button.hidden = !canUseDialog || (hasDefaultVariant && !button.matches('.soyul-details-size-link,.soyul-accordion-size-link'));
        on(button, 'click', event => {
          event.preventDefault();
          event.stopPropagation();
          if (button.matches('.soyul-size-trigger') && inlineChoice && !inlineChoice.hidden) return focusChoice();
          open(button);
        });
      });
      rows.forEach(row => on(row, 'click', () => {
        if (row.disabled) return;
        main.value = row.dataset.soyulSizeId;
        main.dispatchEvent(new Event('change', {bubbles:true}));
        if (dialog.open) dialog.close();
      }));
      on(main, 'change', () => {
        if (root.dataset.purchaseBusy === 'true') return;
        const variant = variants.find(v => String(v.id) === main.value);
        chosen = !!variant;
        if (variant && separateColor) selectedColor = optionAt(variant, colorIndex);
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant', String(variant.id));
        else url.searchParams.delete('variant');
        history.replaceState(history.state, '', url);
        sync();
        root.dispatchEvent(new CustomEvent('soyul:variant-change', {detail:{variant:variant || null}}));
      });
      if (compactSelect) on(compactSelect, 'change', () => {
        main.value = compactSelect.value;
        main.dispatchEvent(new Event('change', {bubbles:true}));
      });
      if (canUseDialog) main.closest('.soyul-native-variant').hidden = true;
      if (measuresToggle && measuresPanel) on(measuresToggle, 'click', () => {
        hydrateMeasures();
        const expanded = measuresToggle.getAttribute('aria-expanded') === 'true';
        measuresToggle.setAttribute('aria-expanded', String(!expanded));
        measuresPanel.hidden = expanded;
      });
      if (canUseDialog) {
      on(dialog.querySelector('[data-soyul-size-close]'), 'click', () => dialog.close());
      on(dialog, 'close', () => {
        document.documentElement.classList.remove('soyul-size-open');
        opener?.focus({preventScroll:true});
      });
      on(dialog, 'click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      }
      on(form, 'submit', event => {
        if (root.dataset.purchaseBusy === 'true') {
          event.preventDefault(); event.stopImmediatePropagation(); return;
        }
        if (!chosen || root.dataset.soyulCanPurchase !== 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          open(submit);
        }
      }, {capture:true});
      function focusChoice() {
        const target = inlineChoice && !inlineChoice.hidden ? inlineChoice : main;
        target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'center'});
        (target === main ? main : colorButtons.find(button => !button.disabled) || rows.find(row => !row.disabled) || main).focus({preventScroll:true});
      }
      on(compact, 'click', event => {
        event.preventDefault();
        event.stopPropagation();
        if (root.dataset.purchaseBusy === 'true') return;
        if (!chosen) focusChoice();
        else if (!submit.disabled) form.requestSubmit(submit);
      });
      // Variant hydration also emits this event on first load. Do not treat
      // that technical initialization as an intentional size choice.
      on(root, 'soyul:variant-change', sync);
      // Reveal the floating purchase bar only after the main purchase area has
      // been passed, then keep it available through the editorial product story.
      let frame = 0;
      const dock = () => {
        frame = 0;
        const bounds = submit.getBoundingClientRect();
        const endBounds = floatingEnd?.getBoundingClientRect();
        const headerOffset = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 90;
        const beforeRecommendations = !endBounds || endBounds.top > headerOffset + 80;
        const floating = bounds.bottom < headerOffset + 12 && beforeRecommendations;
        bar.hidden = !floating;
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(dock); };
      // Horizon scrolls the document on mobile and .page-wrapper on desktop.
      // Listen to both so the rail never becomes stale after a breakpoint change.
      on(document, 'scroll', schedule, {passive:true});
      if (pageWrapper) on(pageWrapper, 'scroll', schedule, {passive:true});
      on(window, 'resize', schedule, {passive:true});
      if (window.visualViewport) on(window.visualViewport, 'resize', schedule, {passive:true});
      const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
      resize?.observe(root);
      root.dataset.purchaseReady = 'true';
      root.querySelector('[data-soyul-compact-actions]').hidden = false;
      on(root, 'soyul:purchase-state', event => {
        root.dataset.purchaseBusy = String(event.detail.busy);
        sync();
      });
      sync(); dock();
      on(document, 'shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        if (dialog?.open) dialog.close();
        document.documentElement.classList.remove('soyul-size-open');
        resize?.disconnect(); cancelAnimationFrame(frame); controller.abort();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => queueMicrotask(() => init(event.target)));
})();
